import type { RouteObject } from 'react-router';
import { institutionRoutePatterns } from '@/institution/constants/routes';

export const institutionRouteChildren: RouteObject[] = [
  {
    path: institutionRoutePatterns.dashboard,
    lazy: () => import('@/institution/pages/dashboard-page').then((m) => ({ Component: m.DashboardPage })),
  },
  {
    path: institutionRoutePatterns.users,
    lazy: () => import('@/institution/pages/users-page').then((m) => ({ Component: m.UsersPage })),
  },
  {
    path: institutionRoutePatterns.groups,
    lazy: () => import('@/institution/pages/groups-page').then((m) => ({ Component: m.GroupsPage })),
  },
  {
    path: institutionRoutePatterns.billing,
    lazy: () => import('@/institution/pages/billing-page').then((m) => ({ Component: m.BillingPage })),
  },
  {
    path: institutionRoutePatterns.notifications,
    lazy: () =>
      import('@/institution/pages/notifications-page').then((m) => ({
        Component: m.NotificationsPage,
      })),
  },
  {
    path: institutionRoutePatterns.profile,
    lazy: () => import('@/institution/pages/profile-page').then((m) => ({ Component: m.ProfilePage })),
  },
];
